module.exports = __webpack_public_path__ + "static/media/meta.978c1206.png";